
    import * as React from 'react';

    const Zoom60 = ({ color = 'currentcolor', height = '60px', width = '60px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 60 60" style={svgStyle}><g><path d="M30 60c16.568 0 30-13.432 30-30C60 13.432 46.568 0 30 0 13.432 0 0 13.432 0 30c0 16.568 13.432 30 30 30zm0-1C13.984 59 1 46.016 1 30S13.984 1 30 1s29 12.984 29 29-12.984 29-29 29z" /><path d="M30.261 29.258h9.262v1h-9.262v9.265h-1v-9.265H20v-1h9.261V20h1v9.258z" /></g></svg>
        </div>
      );
    };

    Zoom60.displayName = 'Zoom60';

    export default Zoom60;
  